import { render, staticRenderFns } from "./controls.vue?vue&type=template&id=169d7bd8"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('169d7bd8')) {
      api.createRecord('169d7bd8', component.options)
    } else {
      api.reload('169d7bd8', component.options)
    }
    module.hot.accept("./controls.vue?vue&type=template&id=169d7bd8", function () {
      api.rerender('169d7bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/visit_manage/visit_step_form/form/components/controls.vue"
export default component.exports